export const combineActions = (...actions) => ({ type }) => {
  return actions.some(action => action.type === type);
};
